import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormFull = _resolveComponent("FormFull");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_ctx.cls)
    }, [
        _createVNode(_component_FormFull, {
            modelValue: _ctx.constructedColorForm,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.constructedColorForm) = $event)),
            id: _ctx.formId,
            spacing: "0"
        }, null, 8, ["modelValue", "id"])
    ], 2));
}
